export default "__VITE_ASSET__DSNrGqyQ__"